// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2SksT","title":"AfterFrontImage_title__hjhiI"};